import { Box, Divider, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { IAdjustmentReadResourceV22 } from 'components/basket/model/Basket';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { CouponItem } from 'components/order/coupons/CouponItem';
import { CouponInput } from 'components/order/coupons/CouponInput';

const PREFIX = 'PayCoupons';

const classes = {
    title: `${PREFIX}title`,
    linkText: `${PREFIX}linkText`
};

const StyledBox = styled(Box)(({ theme }) => ({
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [`& .${classes.title}`]: {
        fontWeight: 700,
        fontSize: '18px'
    },

    [`& .${classes.linkText}`]: {
        fontWeight: 700,
        color: theme.palette.primary.main
    }
}));

interface PayCouponsProps {
    onAdd: (coupon: string) => void;
    coupons?: IAdjustmentReadResourceV22[];
    loading?: boolean;
    onRemove: (coupon: string) => void;
}

export const PayCoupons: React.FC<React.PropsWithChildren<PayCouponsProps>> = ({
    onAdd,
    coupons,
    loading,
    onRemove
}) => {
    const { t } = useTranslation();
    const handleRemoveCoupon = React.useCallback(
        (coupon?: string) => {
            if (coupon) {
                onRemove(coupon);
            }
        },
        [onRemove]
    );
    const renderCoupon = React.useCallback(
        (adjustment: IAdjustmentReadResourceV22) => (
            <CouponItem onClick={handleRemoveCoupon} adjustment={adjustment} key={adjustment.couponCode} />
        ),
        [handleRemoveCoupon]
    );
    if (loading) {
        return null;
    }
    return (
        <StyledBox>
            <Typography className={classes.title}>{t('CHECKOUT_COUPON_TITLE')}</Typography>
            <Box>{coupons?.map(renderCoupon)}</Box>
            <Box mt={2}>
                <CouponInput onAdd={onAdd} />
            </Box>
            <Box pt={1}>
                <Divider />
            </Box>
        </StyledBox>
    );
};
